import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import classNames from "classnames";
import * as c from "./pageHeaderImagesSection.module.scss";

const PageHeaderImagesSection = ({
  currentImages: { desktop, mobile },
  isPaymentsPage,
  isShowcasePage,
  isFeaturePage,
  includeWave,
  isDirectMailPage,
  label,
}) => {
  if (!desktop && !mobile) return null;
  return (
    <div
      className={classNames(isShowcasePage || isFeaturePage ? c.featurePageImageContainer : c.imageContainer, {
        [c.usesMobileImage]: mobile,
        [c.landingContainer]: includeWave,
        [c.paymentsPage]: isPaymentsPage,
        [c.directMailImage]: isDirectMailPage,
      })}
    >
      {desktop && (
        <GatsbyImage
          image={getImage(desktop)}
          className={c.desktopImage}
          loading="eager"
          alt={label ? `${label} - Desktop image` : "Desktop image"}
        />
      )}
      {mobile && (
        <GatsbyImage
          image={getImage(mobile)}
          className={c.mobileImage}
          loading="eager"
          alt={label ? `${label} - Mobile image` : "Mobile image"}
        />
      )}
    </div>
  );
};

export default PageHeaderImagesSection;
